export function corporations() {

return [
  {
    "Name": "AERO PORT SERVICES, INC.",
    "Employees": 717
  },
  {
    "Name": "AIR FAYRE CA INC",
    "Employees": 165
  },
  {
    "Name": "AIR SERV CORPORATION",
    "Employees": 687
  },
  {
    "Name": "AIRCRAFT SERVICE INTERNATIONAL INC",
    "Employees": 284
  },
  {
    "Name": "AIRPORT MANAGEMENT SERVICES",
    "Employees": 509
  },
  {
    "Name": "ALASKA AIR",
    "Employees": 299
  },
  {
    "Name": "ALLIANCE GROUND INTERNATIONAL LLC",
    "Employees": 358
  },
  {
    "Name": "ALLIED UNIVERSAL SECURITY SERVICES",
    "Employees": 126
  },
  {
    "Name": "AMERICAN AIRLINES 0478",
    "Employees": 4469
  },
  {
    "Name": "AREAS USA LAX LLC",
    "Employees": 609
  },
  {
    "Name": "ATS",
    "Employees": 192
  },
  {
    "Name": "AVIATION SAFEGUARDS",
    "Employees": 565
  },
  {
    "Name": "CALOP AEROGROUND",
    "Employees": 310
  },
  {
    "Name": "CERTIFIED AVIATION SERVICES, LLC.",
    "Employees": 124
  },
  {
    "Name": "COMPASS AIRLINES LLC",
    "Employees": 126
  },
  {
    "Name": "CREWS LAX 2 LLC",
    "Employees": 108
  },
  {
    "Name": "CREWSOF CALIFORNIA",
    "Employees": 246
  },
  {
    "Name": "DELAWARE NORTH COMPANIES",
    "Employees": 274
  },
  {
    "Name": "DELTA AIRLINES, INC",
    "Employees": 2205
  },
  {
    "Name": "DFS",
    "Employees": 349
  },
  {
    "Name": "DHL EXPRESS",
    "Employees": 323
  },
  {
    "Name": "ENVOY",
    "Employees": 435
  },
  {
    "Name": "FEDEX",
    "Employees": 2870
  },
  {
    "Name": "G2 SECURE STAFF",
    "Employees": 2245
  },
  {
    "Name": "GATE GOURMET INC",
    "Employees": 270
  },
  {
    "Name": "GATE SAFE, INC.",
    "Employees": 120
  },
  {
    "Name": "GATEWAY FRONTLINE SERVICES INC",
    "Employees": 134
  },
  {
    "Name": "GRIFFITH COFFMAN JV",
    "Employees": 105
  },
  {
    "Name": "HALLMARK",
    "Employees": 807
  },
  {
    "Name": "HORIZON AIR",
    "Employees": 206
  },
  {
    "Name": "HOST",
    "Employees": 1036
  },
  {
    "Name": "I LOVE L.A.",
    "Employees": 106
  },
  {
    "Name": "JETBLUE AIRWAYS CORPORATION",
    "Employees": 125
  },
  {
    "Name": "KOREAN AIRLINES",
    "Employees": 170
  },
  {
    "Name": "L. A. CITY FIRE DEPT",
    "Employees": 243
  },
  {
    "Name": "L. A. CITY POLICE DEPT",
    "Employees": 204
  },
  {
    "Name": "L. A. CITY WATER AND POWER",
    "Employees": 282
  },
  {
    "Name": "LAWA",
    "Employees": 158
  },
  {
    "Name": "LS AND PARTNERS AT CA",
    "Employees": 132
  },
  {
    "Name": "LSG/SKY CHEFS, INC.",
    "Employees": 194
  },
  {
    "Name": "MATRIX AVIATION SVCS",
    "Employees": 304
  },
  {
    "Name": "MENZIES AVIATION USA INC",
    "Employees": 1033
  },
  {
    "Name": "MERCURY",
    "Employees": 597
  },
  {
    "Name": "MORROW MEADOWS",
    "Employees": 316
  },
  {
    "Name": "NEW TECH AIRCRAFT SERVICES",
    "Employees": 138
  },
  {
    "Name": "PACIFIC AVIATION CORP",
    "Employees": 477
  },
  {
    "Name": "PERFORMANCE CONTRACTING INC",
    "Employees": 116
  },
  {
    "Name": "PHELPS DEVELOPMENT/HENSEL PHELPS CONSTRUCTION CO",
    "Employees": 199
  },
  {
    "Name": "RAYTHEON",
    "Employees": 373
  },
  {
    "Name": "S A S SERVICES GROUP INC",
    "Employees": 202
  },
  {
    "Name": "SASCO",
    "Employees": 163
  },
  {
    "Name": "SOCAL CONCESSIONS",
    "Employees": 131
  },
  {
    "Name": "SODEXO AMERICA LLC",
    "Employees": 151
  },
  {
    "Name": "SODEXO MAGIC LLC",
    "Employees": 244
  },
  {
    "Name": "SOUTHWEST AIR",
    "Employees": 893
  },
  {
    "Name": "SWISSPORT CARGO SERVICES",
    "Employees": 356
  },
  {
    "Name": "SWISSPORT SA LLC",
    "Employees": 1306
  },
  {
    "Name": "TOTAL AIRPORT SERVICES",
    "Employees": 401
  },
  {
    "Name": "U S  DHS - TSA",
    "Employees": 2819
  },
  {
    "Name": "U. S.  D.H.S. -  CBP",
    "Employees": 1076
  },
  {
    "Name": "U. S.  D.H.S. -  ICE",
    "Employees": 248
  },
  {
    "Name": "U. S.  F.A.A.",
    "Employees": 170
  },
  {
    "Name": "U. S.  POSTAL SVC",
    "Employees": 171
  },
  {
    "Name": "UNITED AIRLINES",
    "Employees": 2950
  },
  {
    "Name": "VIRGIN AMERICA AIRLINES",
    "Employees": 267
  },
  {
    "Name": "WORLD SERVICE WEST LA",
    "Employees": 219
  },
  {
    "Name": "WORLDWIDE FLIGHT SERVICES",
    "Employees": 744
  },
  {
    "Name": "Corporation Name",
    "Employees": "Employees"
  },
  {
    "Name": "21CFLIGHT INC",
    "Employees": 12
  },
  {
    "Name": "24 7 FIRE PROTECTION SERVICES",
    "Employees": 4
  },
  {
    "Name": "24 HOURS SWEEPING INC",
    "Employees": 4
  },
  {
    "Name": "360 EVENTS AND PROMOTIONS",
    "Employees": 8
  },
  {
    "Name": "3DI SYSTEMS INC",
    "Employees": 1
  },
  {
    "Name": "A AND A RESTORATION",
    "Employees": 1
  },
  {
    "Name": "A AND R DRYWALL",
    "Employees": 2
  },
  {
    "Name": "A C CUSTOM CATERING INC",
    "Employees": 21
  },
  {
    "Name": "AAPC LOUNGE SERVICES",
    "Employees": 3
  },
  {
    "Name": "ABM BUILDING SOLUTIONS LLC",
    "Employees": 9
  },
  {
    "Name": "ABX AIR",
    "Employees": 27
  },
  {
    "Name": "AC MARTIN PARTNERS INC",
    "Employees": 4
  },
  {
    "Name": "ACCESSIBLE CONSULTING ENGINEER",
    "Employees": 1
  },
  {
    "Name": "ACCO ENGINEERED SYSTEMS",
    "Employees": 10
  },
  {
    "Name": "ACCUFLEET",
    "Employees": 38
  },
  {
    "Name": "ADECCO TRANSPORTATION",
    "Employees": 1
  },
  {
    "Name": "ADKAN ENGINEERS",
    "Employees": 3
  },
  {
    "Name": "ADVANCE FIRE PROTECTION CO INC",
    "Employees": 7
  },
  {
    "Name": "ADVANCED ELECTRONICS",
    "Employees": 8
  },
  {
    "Name": "AECOM TECHNICAL SERVICES INC",
    "Employees": 9
  },
  {
    "Name": "AERO BRIDGEWORKS",
    "Employees": 4
  },
  {
    "Name": "AERO UNION",
    "Employees": 76
  },
  {
    "Name": "AEROFLOT",
    "Employees": 4
  },
  {
    "Name": "AERONAUTICAL RADIO INC.",
    "Employees": 9
  },
  {
    "Name": "AEROPORT GROUND SERVICE INC",
    "Employees": 5
  },
  {
    "Name": "AEROTEK AVIATION",
    "Employees": 16
  },
  {
    "Name": "AEROVIAS DE MEXICO SA DE CV",
    "Employees": 26
  },
  {
    "Name": "AHERN RENTALS",
    "Employees": 7
  },
  {
    "Name": "AIR BALANCE COMPANY",
    "Employees": 4
  },
  {
    "Name": "AIR CANADA",
    "Employees": 89
  },
  {
    "Name": "AIR CHINA",
    "Employees": 27
  },
  {
    "Name": "AIR CLEANING TECHNOLOGY, INC",
    "Employees": 25
  },
  {
    "Name": "AIR FRANCE",
    "Employees": 50
  },
  {
    "Name": "AIR NEW ZEALAND",
    "Employees": 47
  },
  {
    "Name": "AIR PACIFIC",
    "Employees": 5
  },
  {
    "Name": "AIR TAHITI NUI",
    "Employees": 4
  },
  {
    "Name": "AIR TEC",
    "Employees": 2
  },
  {
    "Name": "AIR TO GROUND SERVICES",
    "Employees": 40
  },
  {
    "Name": "AIR TRANSPORT INTL LLC",
    "Employees": 3
  },
  {
    "Name": "AIR TRANSPORT IT SERVICES",
    "Employees": 9
  },
  {
    "Name": "AIRBEST HEATING AND AIR CONDITIONING",
    "Employees": 5
  },
  {
    "Name": "AIRCARGO AMERICAS",
    "Employees": 10
  },
  {
    "Name": "AIRPORT MAINTENANCE COMPANY",
    "Employees": 7
  },
  {
    "Name": "AIRPORT TERMINAL MANAGEMENT INC",
    "Employees": 92
  },
  {
    "Name": "AJK COMMUNICATIONS INC",
    "Employees": 5
  },
  {
    "Name": "ALAMEDA CONSTRUCTION SERVICES INC",
    "Employees": 2
  },
  {
    "Name": "ALDRIDGE ELECTRIC INC",
    "Employees": 3
  },
  {
    "Name": "ALL AMERICAN CRANE",
    "Employees": 1
  },
  {
    "Name": "ALL NIPPON AIRWAYS",
    "Employees": 38
  },
  {
    "Name": "ALLEGIANT AIR",
    "Employees": 16
  },
  {
    "Name": "ALLIANT CREDIT UNION",
    "Employees": 4
  },
  {
    "Name": "ALLIED PROTECTION SERVICES INC",
    "Employees": 86
  },
  {
    "Name": "ALLIED STEEL CO INC",
    "Employees": 2
  },
  {
    "Name": "ALOHA AIR CARGO",
    "Employees": 4
  },
  {
    "Name": "ALTA ENVIRONMENTAL",
    "Employees": 17
  },
  {
    "Name": "ALTITUDE INC",
    "Employees": 13
  },
  {
    "Name": "AMEC ENVIRONMENT AND INFRASTRUCTURE",
    "Employees": 7
  },
  {
    "Name": "AMERICAN AIR BALANCE",
    "Employees": 6
  },
  {
    "Name": "AMERICAN AIRLINES",
    "Employees": 4
  },
  {
    "Name": "AMERICAN BUILDING MTCE",
    "Employees": 48
  },
  {
    "Name": "AMERICAN GUARD SERVICES INC",
    "Employees": 40
  },
  {
    "Name": "AMERICAN INTEGRATED RESOURCES",
    "Employees": 1
  },
  {
    "Name": "AMERIGUARD MAINTENANCE SERVICES",
    "Employees": 6
  },
  {
    "Name": "ANDERSEN ENVIRONMENTAL",
    "Employees": 14
  },
  {
    "Name": "ANDY FRAIN SERVICES INC",
    "Employees": 2
  },
  {
    "Name": "ANHEUSER BUSCH SALES OF LA",
    "Employees": 11
  },
  {
    "Name": "ANIK INTERNATIONAL",
    "Employees": 19
  },
  {
    "Name": "ANNING JOHNSON",
    "Employees": 3
  },
  {
    "Name": "ANTIGO CONSTRUCTION INC",
    "Employees": 1
  },
  {
    "Name": "APPLIED ENGINEERING CONCEPTS",
    "Employees": 9
  },
  {
    "Name": "ARAGON PROJECT MANAGEMENT",
    "Employees": 1
  },
  {
    "Name": "ARAMARK REFRESHMENT SERVICES",
    "Employees": 2
  },
  {
    "Name": "ARAMARK UNIFORMS",
    "Employees": 5
  },
  {
    "Name": "ARCHITECTURAL DESIGN & SIGNS, INC",
    "Employees": 9
  },
  {
    "Name": "AREAS OHM LAX JV LLC",
    "Employees": 6
  },
  {
    "Name": "AREAS SKYVIEW LAX JV LLC",
    "Employees": 62
  },
  {
    "Name": "ARROW SERVICE INC",
    "Employees": 9
  },
  {
    "Name": "ARROWHEAD WATER",
    "Employees": 1
  },
  {
    "Name": "ARUP NORTH AMERICA, LTD",
    "Employees": 17
  },
  {
    "Name": "ASBURY ENVIRONMENTAL SERVICES",
    "Employees": 2
  },
  {
    "Name": "ASIANA",
    "Employees": 42
  },
  {
    "Name": "ASKARI SECURITY SERVICES",
    "Employees": 48
  },
  {
    "Name": "AT AND T CALIFORNIA",
    "Employees": 39
  },
  {
    "Name": "ATHENX INC",
    "Employees": 6
  },
  {
    "Name": "ATKINS NORTH AMERICA",
    "Employees": 1
  },
  {
    "Name": "ATLANTIC AVIATION",
    "Employees": 53
  },
  {
    "Name": "AUSTRALIAN CONSULATE",
    "Employees": 5
  },
  {
    "Name": "AVAIRPROS",
    "Employees": 32
  },
  {
    "Name": "AVAIRPROS SERVICES INC",
    "Employees": 32
  },
  {
    "Name": "AVB MANAGEMENT PARTNERS",
    "Employees": 27
  },
  {
    "Name": "AVCOGAS PROPANE SALES AND SERVICES",
    "Employees": 7
  },
  {
    "Name": "AVIATION FUEL SYS",
    "Employees": 42
  },
  {
    "Name": "AVIATION PERSONNEL",
    "Employees": 4
  },
  {
    "Name": "AYALA BORING INC",
    "Employees": 3
  },
  {
    "Name": "BAHMAN DANIALI",
    "Employees": 1
  },
  {
    "Name": "BAKER ELECTRIC",
    "Employees": 6
  },
  {
    "Name": "BARNETT ELECTRIC",
    "Employees": 12
  },
  {
    "Name": "BASCON INC",
    "Employees": 2
  },
  {
    "Name": "BE RELAX",
    "Employees": 18
  },
  {
    "Name": "BEARCOM",
    "Employees": 1
  },
  {
    "Name": "BEARING DISTRIBUTORS INC",
    "Employees": 5
  },
  {
    "Name": "BECK STEEL",
    "Employees": 1
  },
  {
    "Name": "BELTMANN INTEGRATED LOGISTICS",
    "Employees": 1
  },
  {
    "Name": "BENESH ELECTRIC",
    "Employees": 4
  },
  {
    "Name": "BERG AND ASSOCIATES",
    "Employees": 3
  },
  {
    "Name": "BEST CONTRACTING SERVICES INC",
    "Employees": 35
  },
  {
    "Name": "BESTWAY SERVICES INC",
    "Employees": 7
  },
  {
    "Name": "BETKON INC",
    "Employees": 3
  },
  {
    "Name": "BEUMER GROUP GLIDEPATH INC",
    "Employees": 5
  },
  {
    "Name": "BEVERLY HILLS RENT A CAR",
    "Employees": 3
  },
  {
    "Name": "BILL GLORE INC",
    "Employees": 3
  },
  {
    "Name": "BIRDI AND ASSOCIATES, INC",
    "Employees": 38
  },
  {
    "Name": "BLACK GOLD INDUSTRIES",
    "Employees": 3
  },
  {
    "Name": "BLOIS CONSTRUCTION INC.",
    "Employees": 26
  },
  {
    "Name": "BLUE STONE MANAGEMENT LLC",
    "Employees": 1
  },
  {
    "Name": "BNP ASSOC.",
    "Employees": 1
  },
  {
    "Name": "BOB HOPE USO",
    "Employees": 11
  },
  {
    "Name": "BOINGO WIRELESS INC",
    "Employees": 8
  },
  {
    "Name": "BORBON INC",
    "Employees": 18
  },
  {
    "Name": "BORDER GRILL",
    "Employees": 7
  },
  {
    "Name": "BOUTIQUE AIR",
    "Employees": 21
  },
  {
    "Name": "BRADCAL INC",
    "Employees": 7
  },
  {
    "Name": "BRADY COMPANY LOS ANGELES INC",
    "Employees": 5
  },
  {
    "Name": "BRAGG CRANE AND RIGGING",
    "Employees": 2
  },
  {
    "Name": "BRINKS",
    "Employees": 22
  },
  {
    "Name": "BRITISH AIRWAYS LTD.",
    "Employees": 69
  },
  {
    "Name": "BROCK SOLUTIONS",
    "Employees": 27
  },
  {
    "Name": "BROOKSTONE",
    "Employees": 8
  },
  {
    "Name": "BROTHERS DISTRIBUTION",
    "Employees": 5
  },
  {
    "Name": "BUILDERS CONSULTANTS INC",
    "Employees": 1
  },
  {
    "Name": "BUILDING ELECTRONIC CONTROLS INC",
    "Employees": 31
  },
  {
    "Name": "BUILDING INTEGRATORS AND SOLUTIONS CORP",
    "Employees": 2
  },
  {
    "Name": "BURNS AND MCDONNELL",
    "Employees": 13
  },
  {
    "Name": "BURNS ENGINEERING",
    "Employees": 1
  },
  {
    "Name": "C A BUCHEN CORP",
    "Employees": 7
  },
  {
    "Name": "C AND S ENGINEERS INC",
    "Employees": 1
  },
  {
    "Name": "C BELOW INC",
    "Employees": 1
  },
  {
    "Name": "C2PM",
    "Employees": 10
  },
  {
    "Name": "CA FACILITIES AND EQUIP MTCE",
    "Employees": 23
  },
  {
    "Name": "CA HIGHWAY PATROL",
    "Employees": 12
  },
  {
    "Name": "CABLE MASTERS",
    "Employees": 12
  },
  {
    "Name": "CAGE",
    "Employees": 6
  },
  {
    "Name": "CALI USA ACOUSTICS",
    "Employees": 9
  },
  {
    "Name": "CALIF DEPT OF FISH AND WILDLIFE",
    "Employees": 6
  },
  {
    "Name": "CALIFORNIA EARTH TRANSPORT INC",
    "Employees": 83
  },
  {
    "Name": "CALIFORNIA FACILITY SPECIALTIES INC",
    "Employees": 2
  },
  {
    "Name": "CALIFORNIA FOOD AND AGRICULTURE",
    "Employees": 39
  },
  {
    "Name": "CALIFORNIA GOURMET KITCHEN, INC.",
    "Employees": 12
  },
  {
    "Name": "CALIFORNIA PUBLIC UTILITIES COMMISSION",
    "Employees": 4
  },
  {
    "Name": "CALIFORNIA WATER TECHNOLOGIES",
    "Employees": 1
  },
  {
    "Name": "CALTROP",
    "Employees": 27
  },
  {
    "Name": "CAMPANILE",
    "Employees": 2
  },
  {
    "Name": "CANTEEN VENDING",
    "Employees": 6
  },
  {
    "Name": "CANYON INSULATION, INC.",
    "Employees": 10
  },
  {
    "Name": "CAPITAL ENGINEERING CONSULTANTS INC",
    "Employees": 5
  },
  {
    "Name": "CAPITOL CONSTRUCTION GROUP",
    "Employees": 1
  },
  {
    "Name": "CARGO HS LLC",
    "Employees": 1
  },
  {
    "Name": "CARGOLUX",
    "Employees": 15
  },
  {
    "Name": "CASARIA TECHNOLOGY",
    "Employees": 10
  },
  {
    "Name": "CATALINA PACIFIC CONCRETE",
    "Employees": 39
  },
  {
    "Name": "CATHAY PACIFIC",
    "Employees": 48
  },
  {
    "Name": "CAVOTEC INET US INC",
    "Employees": 4
  },
  {
    "Name": "CDG TEMPORARY PARKING PRGM",
    "Employees": 59
  },
  {
    "Name": "CDM SMITH INC",
    "Employees": 7
  },
  {
    "Name": "CEED SECURITY SERVICES",
    "Employees": 97
  },
  {
    "Name": "CENTERLINE CONCRETE CUTTING INC",
    "Employees": 5
  },
  {
    "Name": "CHAMPION FIRE SYSTEMS",
    "Employees": 5
  },
  {
    "Name": "CHEM CHEK",
    "Employees": 4
  },
  {
    "Name": "CHEP AEROSPACE SOLUTIONS",
    "Employees": 1
  },
  {
    "Name": "CHEP AEROSPACE SOLUTIONS",
    "Employees": 6
  },
  {
    "Name": "CHEVRON USA",
    "Employees": 4
  },
  {
    "Name": "CHINA AIRLINES",
    "Employees": 59
  },
  {
    "Name": "CHINA CARGO AIRLINES",
    "Employees": 11
  },
  {
    "Name": "CHINA EASTERN",
    "Employees": 14
  },
  {
    "Name": "CHINA SOUTHERN",
    "Employees": 17
  },
  {
    "Name": "CHOICE BOOKS OF NORTHERN VIRGINIA INC",
    "Employees": 2
  },
  {
    "Name": "CHRYSALIS AVIATION SOLUTIONS",
    "Employees": 10
  },
  {
    "Name": "CINTAS",
    "Employees": 9
  },
  {
    "Name": "CLARK/MCCARTHY JV",
    "Employees": 63
  },
  {
    "Name": "CLEAR",
    "Employees": 95
  },
  {
    "Name": "CLIMATEC LLC",
    "Employees": 5
  },
  {
    "Name": "CMSC",
    "Employees": 1
  },
  {
    "Name": "CMTS LLC",
    "Employees": 1
  },
  {
    "Name": "COAST SURVEYING",
    "Employees": 1
  },
  {
    "Name": "COCA COLA REFRESHMENTS",
    "Employees": 26
  },
  {
    "Name": "COLLECTIVE MANAGEMENT SERVICES INC",
    "Employees": 4
  },
  {
    "Name": "COMET ELECTRIC",
    "Employees": 71
  },
  {
    "Name": "COMMERCIAL CLEANING SYSTEMS",
    "Employees": 5
  },
  {
    "Name": "COMMERCIAL SCAFFOLDING",
    "Employees": 10
  },
  {
    "Name": "COMPONENT WEST INC",
    "Employees": 5
  },
  {
    "Name": "CONCO CEMENT AND PUMPING COMPANY",
    "Employees": 61
  },
  {
    "Name": "CONCOURSE CONCESSIONS",
    "Employees": 25
  },
  {
    "Name": "CONCRETE CORING CO",
    "Employees": 11
  },
  {
    "Name": "CONEXUS WORLD GLOBAL LLC",
    "Employees": 4
  },
  {
    "Name": "CONNOR CONCRETE CUTTING AND CORING",
    "Employees": 12
  },
  {
    "Name": "CONSOLIDATED DISPOSAL SERVICE",
    "Employees": 12
  },
  {
    "Name": "CONSTRUCTION MANAGEMENT SOLUTIONS",
    "Employees": 8
  },
  {
    "Name": "CONSUMER PRODUCTS SAFETY COMMISSION",
    "Employees": 2
  },
  {
    "Name": "CONTROL AIR",
    "Employees": 10
  },
  {
    "Name": "CONVERGINT TECHNOLOGIES",
    "Employees": 7
  },
  {
    "Name": "COPA AIRLINES",
    "Employees": 8
  },
  {
    "Name": "CORESTAFF SERVICES",
    "Employees": 9
  },
  {
    "Name": "CORGAN ASSOCIATES",
    "Employees": 32
  },
  {
    "Name": "CORRADINI CORP",
    "Employees": 33
  },
  {
    "Name": "COSCO FIRE PROTECTION",
    "Employees": 39
  },
  {
    "Name": "COWELCO",
    "Employees": 5
  },
  {
    "Name": "CPR TRUCKING",
    "Employees": 19
  },
  {
    "Name": "CPS",
    "Employees": 14
  },
  {
    "Name": "CRAFT BEER GUILD DISTRIBUTING",
    "Employees": 1
  },
  {
    "Name": "CREELMAN AND ASSOCIATES INC",
    "Employees": 2
  },
  {
    "Name": "CREWS LAX 1 LLC",
    "Employees": 83
  },
  {
    "Name": "CRITCHFIELD MECHANICAL INC OF SOUTHERN CALIFORNIA",
    "Employees": 84
  },
  {
    "Name": "CROWN FENCE",
    "Employees": 20
  },
  {
    "Name": "CSA CONSTRUCTORS",
    "Employees": 27
  },
  {
    "Name": "CSI ELECTRICAL CONTRACTORS INC",
    "Employees": 10
  },
  {
    "Name": "CUPERTINO ELECTRIC INC",
    "Employees": 45
  },
  {
    "Name": "CUSTOMER SERVICE EXPERTS",
    "Employees": 22
  },
  {
    "Name": "D AND C DIVERSIFIED CONSULTANTS INC",
    "Employees": 3
  },
  {
    "Name": "D7 CONSULTING",
    "Employees": 1
  },
  {
    "Name": "DABCO INC",
    "Employees": 4
  },
  {
    "Name": "DACO ELECTRIC",
    "Employees": 6
  },
  {
    "Name": "DAKOTA COMMUNICATIONS",
    "Employees": 1
  },
  {
    "Name": "DAL GLOBAL SERVICES LLC",
    "Employees": 64
  },
  {
    "Name": "DAVIDSON CONCRETE CUTTING INC",
    "Employees": 1
  },
  {
    "Name": "DAY STAR",
    "Employees": 1
  },
  {
    "Name": "DECISIONONE",
    "Employees": 9
  },
  {
    "Name": "DFS",
    "Employees": 8
  },
  {
    "Name": "DHA CALPEC",
    "Employees": 6
  },
  {
    "Name": "DHS CONSULTING",
    "Employees": 3
  },
  {
    "Name": "DIAZ YOURMAN AND ASSOCIATES",
    "Employees": 10
  },
  {
    "Name": "DIEBOLD, INC.",
    "Employees": 12
  },
  {
    "Name": "DIGITAL ARCHIVING",
    "Employees": 2
  },
  {
    "Name": "DINA M PROMOTIONS",
    "Employees": 29
  },
  {
    "Name": "DIRECT AV",
    "Employees": 31
  },
  {
    "Name": "DO AND CO LA INC",
    "Employees": 46
  },
  {
    "Name": "DOTY BROS EQUIPMENT COMPANY",
    "Employees": 9
  },
  {
    "Name": "DSM CONSTRUCTION, INC.",
    "Employees": 6
  },
  {
    "Name": "DUGGAN AND ASSOCIATES INC",
    "Employees": 3
  },
  {
    "Name": "DUNBAR ARMORED INCORPORATED",
    "Employees": 14
  },
  {
    "Name": "DYNALECTRIC",
    "Employees": 43
  },
  {
    "Name": "DYNAMIC INTERNATIONAL AIRWAYS",
    "Employees": 1
  },
  {
    "Name": "DYNATEST CONSULTING INC",
    "Employees": 1
  },
  {
    "Name": "E AND J VENDING",
    "Employees": 5
  },
  {
    "Name": "E K ASSOCIATES",
    "Employees": 1
  },
  {
    "Name": "E2 CONSULTING ENGINEERS",
    "Employees": 2
  },
  {
    "Name": "EAGLE SECURITY SERVICES, INC",
    "Employees": 71
  },
  {
    "Name": "EAST ISLAND AVIATION SERVICES, INC",
    "Employees": 1
  },
  {
    "Name": "EATON CORPORATION",
    "Employees": 2
  },
  {
    "Name": "ECI",
    "Employees": 1
  },
  {
    "Name": "ECM CONSULTANTS",
    "Employees": 2
  },
  {
    "Name": "ECO PAN",
    "Employees": 9
  },
  {
    "Name": "ECOLAB, INC.",
    "Employees": 5
  },
  {
    "Name": "ECOLOGY AUTO PARTS",
    "Employees": 1
  },
  {
    "Name": "ECOSERVICES LLC",
    "Employees": 4
  },
  {
    "Name": "EFI GLOBAL INC",
    "Employees": 24
  },
  {
    "Name": "EL AL ISRAEL",
    "Employees": 43
  },
  {
    "Name": "EL PRADO CLEANING SERVICE",
    "Employees": 57
  },
  {
    "Name": "ELECTRICAL COMMUNICATIONS ENGINEERING GROUP",
    "Employees": 1
  },
  {
    "Name": "ELEVATORS ETC",
    "Employees": 6
  },
  {
    "Name": "ELITE LINE SERVICES CALIFORNIA INC",
    "Employees": 28
  },
  {
    "Name": "ELLJAY ACOUSTICS",
    "Employees": 12
  },
  {
    "Name": "EMBRAER AIRCRAFT CUSTOMER SERVICES",
    "Employees": 1
  },
  {
    "Name": "EMIRATES",
    "Employees": 24
  },
  {
    "Name": "ENVIRONMENTAL CONSTRUCTION",
    "Employees": 60
  },
  {
    "Name": "ENVIRONMENTAL SERVICE CONCEPTS",
    "Employees": 6
  },
  {
    "Name": "ER COMMERCIAL SERVICES",
    "Employees": 2
  },
  {
    "Name": "ERM WEST, INC.",
    "Employees": 17
  },
  {
    "Name": "ETHIOPIAN AIRLINES",
    "Employees": 4
  },
  {
    "Name": "ETIHAD AIRWAYS",
    "Employees": 8
  },
  {
    "Name": "EULEN AMERICA",
    "Employees": 14
  },
  {
    "Name": "EVA AIRWAYS",
    "Employees": 50
  },
  {
    "Name": "EXPRESS GROUP CLEANING",
    "Employees": 5
  },
  {
    "Name": "EXTREME PRESSURE SYSTEMS",
    "Employees": 11
  },
  {
    "Name": "F AND E AIRCRAFT MAINTENANCE AND ENGINEERING",
    "Employees": 35
  },
  {
    "Name": "FACILITEC WEST",
    "Employees": 12
  },
  {
    "Name": "FACILITIES ENGINEERING",
    "Employees": 1
  },
  {
    "Name": "FACILITIES PROTECTION SYSTEMS",
    "Employees": 3
  },
  {
    "Name": "FAITH GROUP LLC",
    "Employees": 3
  },
  {
    "Name": "FAITHFUL GOULD",
    "Employees": 2
  },
  {
    "Name": "FERRARI EXPRESS",
    "Employees": 4
  },
  {
    "Name": "FFC SERVICES INC",
    "Employees": 4
  },
  {
    "Name": "FGX INC",
    "Employees": 3
  },
  {
    "Name": "FIREMASTER",
    "Employees": 1
  },
  {
    "Name": "FIRST CHOICE FIRE PROTECTION",
    "Employees": 4
  },
  {
    "Name": "FIRST CLASS VENDING, INC.",
    "Employees": 20
  },
  {
    "Name": "FLAGSHIP AIRPORT SERVICES, INC.",
    "Employees": 25
  },
  {
    "Name": "FLIK INTERNATIONAL CORP",
    "Employees": 54
  },
  {
    "Name": "FLYING FOOD GROUP",
    "Employees": 60
  },
  {
    "Name": "FLYING FOOD GROUP PACIFIC",
    "Employees": 98
  },
  {
    "Name": "FLYNN SCALE SERVICE",
    "Employees": 7
  },
  {
    "Name": "FORDS FILLING STATION",
    "Employees": 1
  },
  {
    "Name": "FOREVER GREEN",
    "Employees": 1
  },
  {
    "Name": "FORTEM GROUP",
    "Employees": 1
  },
  {
    "Name": "FOUNDATION BUILDING MATERIALS",
    "Employees": 5
  },
  {
    "Name": "FRANK SMITH MASONRY",
    "Employees": 8
  },
  {
    "Name": "FRESH AND READY FOODS",
    "Employees": 6
  },
  {
    "Name": "FRONTIER AIRLINES",
    "Employees": 3
  },
  {
    "Name": "FS3 HODGES",
    "Employees": 3
  },
  {
    "Name": "FUJITSU AMERICA",
    "Employees": 6
  },
  {
    "Name": "G AND C EQUIPMENT",
    "Employees": 4
  },
  {
    "Name": "G AND F CONCRETE CUTTING INC",
    "Employees": 14
  },
  {
    "Name": "G AND G DOOR PRODUCTS",
    "Employees": 3
  },
  {
    "Name": "G D HEIL INC",
    "Employees": 10
  },
  {
    "Name": "GAMA AVIATION",
    "Employees": 5
  },
  {
    "Name": "GARNIER GROUP AND ASSOC",
    "Employees": 3
  },
  {
    "Name": "GAVIN DE BECKER AND ASSOCIATES",
    "Employees": 84
  },
  {
    "Name": "GCA SERVICES GROUP",
    "Employees": 51
  },
  {
    "Name": "GENERAL DYNAMICS INFORMATION TECHNOLOGY INC",
    "Employees": 4
  },
  {
    "Name": "GENSLER ASSOCIATES",
    "Employees": 17
  },
  {
    "Name": "GEODESIGN INC",
    "Employees": 13
  },
  {
    "Name": "GEOSYNTEC CONSULTANTS",
    "Employees": 6
  },
  {
    "Name": "GERDAU REINFORCING STEEL",
    "Employees": 17
  },
  {
    "Name": "GEXPRO",
    "Employees": 4
  },
  {
    "Name": "GGG DEMOLITION, INC",
    "Employees": 53
  },
  {
    "Name": "GIROUX GLASS",
    "Employees": 10
  },
  {
    "Name": "GK SERVICES",
    "Employees": 4
  },
  {
    "Name": "GKK WORKS",
    "Employees": 4
  },
  {
    "Name": "GLENN LUKOS ASSOCIATES",
    "Employees": 2
  },
  {
    "Name": "GLOBAL AVIATION MANAGEMENT GROUP",
    "Employees": 89
  },
  {
    "Name": "GLOBAL RESOURCE MGMT",
    "Employees": 20
  },
  {
    "Name": "GLORE AND ASSOCIATES INC",
    "Employees": 2
  },
  {
    "Name": "GLOW ELECTRIC CO INC",
    "Employees": 26
  },
  {
    "Name": "GO WEST BAKERY",
    "Employees": 5
  },
  {
    "Name": "GOSS CONSTRUCTION",
    "Employees": 6
  },
  {
    "Name": "GPA ARCHITECTS INC",
    "Employees": 1
  },
  {
    "Name": "GRAND PERFORMANCES",
    "Employees": 1
  },
  {
    "Name": "GRANITE CONSTRUCTION COMPANY",
    "Employees": 59
  },
  {
    "Name": "GRAYBAR ELECTRIC",
    "Employees": 4
  },
  {
    "Name": "GREAT LAKES AIRLINES",
    "Employees": 11
  },
  {
    "Name": "GRIFFITH COMPANY",
    "Employees": 97
  },
  {
    "Name": "GROUP DELTA CONSULTANTS INC",
    "Employees": 12
  },
  {
    "Name": "GRUEN ASSOCIATES",
    "Employees": 1
  },
  {
    "Name": "GSA AIR USA LLC",
    "Employees": 5
  },
  {
    "Name": "GURCINAS",
    "Employees": 2
  },
  {
    "Name": "H AND E EQUIPMENT SERVICES",
    "Employees": 5
  },
  {
    "Name": "HACOR, INC.",
    "Employees": 91
  },
  {
    "Name": "HAINAN AIRLINES",
    "Employees": 7
  },
  {
    "Name": "HALEY AND ALDRICH INC",
    "Employees": 5
  },
  {
    "Name": "HARWOOD CONSTRUCTION",
    "Employees": 14
  },
  {
    "Name": "HASSON PAINTING CONTRACTORS",
    "Employees": 3
  },
  {
    "Name": "HAVANA HOUSE GIFTS AND NEWS",
    "Employees": 2
  },
  {
    "Name": "HAWAIIAN AIR",
    "Employees": 69
  },
  {
    "Name": "HEARLSON",
    "Employees": 3
  },
  {
    "Name": "HELIX",
    "Employees": 20
  },
  {
    "Name": "HIGGINSWORKS",
    "Employees": 3
  },
  {
    "Name": "HILL CRANE SERVICE INC",
    "Employees": 7
  },
  {
    "Name": "HILL/APSI JV",
    "Employees": 11
  },
  {
    "Name": "HNTB",
    "Employees": 26
  },
  {
    "Name": "HOLONYNE",
    "Employees": 2
  },
  {
    "Name": "HORIZON AVIATION SERVICES",
    "Employees": 55
  },
  {
    "Name": "HORTON LEES BROGDEN LIGHTING",
    "Employees": 3
  },
  {
    "Name": "HP INC",
    "Employees": 1
  },
  {
    "Name": "HUNT DESIGN ASSOCIATES",
    "Employees": 4
  },
  {
    "Name": "HUNTLEIGH",
    "Employees": 24
  },
  {
    "Name": "IAG CARGO",
    "Employees": 2
  },
  {
    "Name": "IBC, INC.",
    "Employees": 12
  },
  {
    "Name": "IBERIA AIRLINES OF SPAIN",
    "Employees": 2
  },
  {
    "Name": "IBTECH STAFFING",
    "Employees": 6
  },
  {
    "Name": "ICE CURRENCY SERVICES USA",
    "Employees": 45
  },
  {
    "Name": "ICSS",
    "Employees": 42
  },
  {
    "Name": "IDM GROUPS LLC",
    "Employees": 1
  },
  {
    "Name": "IFACTOR",
    "Employees": 3
  },
  {
    "Name": "IG PC SERVICES",
    "Employees": 1
  },
  {
    "Name": "IMMACULATE FLIGHT",
    "Employees": 11
  },
  {
    "Name": "IMPERIAL SECURITY SERVICES",
    "Employees": 38
  },
  {
    "Name": "INDUSTRIAL TECHNICAL SERVICES",
    "Employees": 3
  },
  {
    "Name": "INDUSTRIAL TELEVISION SERVICES, INC.",
    "Employees": 1
  },
  {
    "Name": "INFINITY DRYWALL",
    "Employees": 43
  },
  {
    "Name": "INFINITY METALS INC",
    "Employees": 3
  },
  {
    "Name": "INMOTION ENTERTAINMENT GROUP",
    "Employees": 10
  },
  {
    "Name": "INTEGRATED ENGINEERING MANAGEMENT",
    "Employees": 2
  },
  {
    "Name": "INTEGRATED PROJECT CONTROLS TEAM JV",
    "Employees": 37
  },
  {
    "Name": "INTEGRATED SECURITY SOLUTIONS INC",
    "Employees": 1
  },
  {
    "Name": "INTERJET",
    "Employees": 3
  },
  {
    "Name": "INTERLOC SOLUTIONS INC",
    "Employees": 2
  },
  {
    "Name": "IOM",
    "Employees": 12
  },
  {
    "Name": "IPDM LLC",
    "Employees": 1
  },
  {
    "Name": "ISEC",
    "Employees": 75
  },
  {
    "Name": "J AND H ENTERPRISES",
    "Employees": 13
  },
  {
    "Name": "J AND J CONSTRUCTION",
    "Employees": 1
  },
  {
    "Name": "J COLAVIN AND SON",
    "Employees": 10
  },
  {
    "Name": "J PEREZ ASSOCIATES INC",
    "Employees": 14
  },
  {
    "Name": "JACOB AND HEFNER ASSOCIATES",
    "Employees": 1
  },
  {
    "Name": "JACOBS ENGINEERING",
    "Employees": 9
  },
  {
    "Name": "JACOBS PROJECT MANAGEMENT",
    "Employees": 10
  },
  {
    "Name": "JACOBSEN DANIELS",
    "Employees": 12
  },
  {
    "Name": "JAPAN AIRLINES",
    "Employees": 45
  },
  {
    "Name": "JBI LLC",
    "Employees": 11
  },
  {
    "Name": "JBT AEROTECH",
    "Employees": 84
  },
  {
    "Name": "JC PROMOTIONS INC",
    "Employees": 1
  },
  {
    "Name": "JCDECAUX AIRPORT INC",
    "Employees": 32
  },
  {
    "Name": "JEN AIR LLC",
    "Employees": 6
  },
  {
    "Name": "JET PETS INC",
    "Employees": 8
  },
  {
    "Name": "JETWAY EXPRESS",
    "Employees": 8
  },
  {
    "Name": "JGM DESIGN INC",
    "Employees": 12
  },
  {
    "Name": "JGM SERVICES",
    "Employees": 3
  },
  {
    "Name": "JH CONSTRUCTION",
    "Employees": 3
  },
  {
    "Name": "JHA ENVIRONMENTAL",
    "Employees": 16
  },
  {
    "Name": "JMS SITE SERVICES INC",
    "Employees": 2
  },
  {
    "Name": "JOHN A MARTIN AND ASSOC INC",
    "Employees": 4
  },
  {
    "Name": "JOHNSON AND TURNER PAINTING",
    "Employees": 6
  },
  {
    "Name": "JOHNSON CONTROLS",
    "Employees": 26
  },
  {
    "Name": "JONES AND JONES CONSTRUCTION",
    "Employees": 8
  },
  {
    "Name": "JORDIM",
    "Employees": 3
  },
  {
    "Name": "K2 CONSTRUCTION CONSULTANTS",
    "Employees": 2
  },
  {
    "Name": "KAL KRISHNAN CONSULTING SVCS",
    "Employees": 2
  },
  {
    "Name": "KALITTA AIR LLC",
    "Employees": 7
  },
  {
    "Name": "KANDA PROJECT SERVICES CORPORATION",
    "Employees": 1
  },
  {
    "Name": "KARCHER FIRESTOPPING",
    "Employees": 4
  },
  {
    "Name": "KARCHER INSULATION",
    "Employees": 6
  },
  {
    "Name": "KARCHER INTERIOR SYSTEMS",
    "Employees": 5
  },
  {
    "Name": "KAROL WESTERN",
    "Employees": 3
  },
  {
    "Name": "KDG DEVELOPMENT",
    "Employees": 30
  },
  {
    "Name": "KELLAR SWEEPING",
    "Employees": 1
  },
  {
    "Name": "KEY AIR CONDITIONING CONTRACTORS INC",
    "Employees": 9
  },
  {
    "Name": "KIMLEY HORN AND ASSOCIATES",
    "Employees": 6
  },
  {
    "Name": "KING EQUIPMENT",
    "Employees": 18
  },
  {
    "Name": "KLEINFELDER WEST INC",
    "Employees": 2
  },
  {
    "Name": "KLM",
    "Employees": 4
  },
  {
    "Name": "KLX AEROSPACE SOLUTIONS",
    "Employees": 4
  },
  {
    "Name": "KNEWSALES GROUP",
    "Employees": 8
  },
  {
    "Name": "KT INDUSTRIES INC",
    "Employees": 3
  },
  {
    "Name": "L RILEY TRUCKING AND DISPATCH",
    "Employees": 11
  },
  {
    "Name": "L. A. CITY ATTORNEY",
    "Employees": 33
  },
  {
    "Name": "L. A. CITY BUILDING AND SAFETY",
    "Employees": 78
  },
  {
    "Name": "L. A. CITY BUREAU OF SANITATION",
    "Employees": 21
  },
  {
    "Name": "L. A. CITY CONTROLLER",
    "Employees": 4
  },
  {
    "Name": "L. A. CITY CULTURAL AFFAIRS",
    "Employees": 9
  },
  {
    "Name": "L. A. CITY PUBLIC WORKS",
    "Employees": 33
  },
  {
    "Name": "L. A. COUNTY AGRICULTURE",
    "Employees": 25
  },
  {
    "Name": "L. A. COUNTY ASSESSOR",
    "Employees": 8
  },
  {
    "Name": "L. A. COUNTY DISTRICT ATTORNEY",
    "Employees": 4
  },
  {
    "Name": "L. A. COUNTY ENVIRONMENTAL HEALTH SERVICES",
    "Employees": 15
  },
  {
    "Name": "L. A. COUNTY FIRE DEPT.",
    "Employees": 3
  },
  {
    "Name": "L. A. COUNTY WEST VECTOR CONTROL",
    "Employees": 5
  },
  {
    "Name": "L.A. COUNTY DEPARTMENT OF PUBLIC HEALTH",
    "Employees": 20
  },
  {
    "Name": "L3 COMMUNICATIONS",
    "Employees": 3
  },
  {
    "Name": "LA BREA BAKERY",
    "Employees": 10
  },
  {
    "Name": "LA PROVENCE PATISSERIE",
    "Employees": 1
  },
  {
    "Name": "LAN CARGO SA",
    "Employees": 8
  },
  {
    "Name": "LANDMARK AVIATION",
    "Employees": 22
  },
  {
    "Name": "LARDER AT TAVERN",
    "Employees": 4
  },
  {
    "Name": "LATAM AIRLINES GROUP SA",
    "Employees": 3
  },
  {
    "Name": "LAWRENCE B BONAS COMPANY",
    "Employees": 2
  },
  {
    "Name": "LAWRENCE W ROSINE CO",
    "Employees": 10
  },
  {
    "Name": "LAWSON BROS LLC",
    "Employees": 3
  },
  {
    "Name": "LAX - AIRFIELD OPS",
    "Employees": 1
  },
  {
    "Name": "LAX - AIRPORT OPS",
    "Employees": 1
  },
  {
    "Name": "LAX AUTO PARTS INC",
    "Employees": 4
  },
  {
    "Name": "LE CHEF BAKERY",
    "Employees": 4
  },
  {
    "Name": "LEA ELLIOTT",
    "Employees": 8
  },
  {
    "Name": "LEE ANDREWS GROUP",
    "Employees": 4
  },
  {
    "Name": "LEMONADE RESTAURANT GROUP LLC",
    "Employees": 7
  },
  {
    "Name": "LEO A DALY",
    "Employees": 4
  },
  {
    "Name": "LETNER ROOFING CO",
    "Employees": 29
  },
  {
    "Name": "LGM CONSTRUCTION CO",
    "Employees": 6
  },
  {
    "Name": "LOOMIS ARMORED",
    "Employees": 8
  },
  {
    "Name": "LOS ANGELES CITY GENERAL SERVICES",
    "Employees": 60
  },
  {
    "Name": "LOT POLISH AIRLINES",
    "Employees": 2
  },
  {
    "Name": "LOTERIA GRILL RESTAURANT",
    "Employees": 2
  },
  {
    "Name": "LRA WORLDWIDE INC",
    "Employees": 14
  },
  {
    "Name": "LS AND PARTNERS AT LAX LLC",
    "Employees": 87
  },
  {
    "Name": "LUFTHANSA",
    "Employees": 60
  },
  {
    "Name": "LUTRON SERVICES CO INC",
    "Employees": 5
  },
  {
    "Name": "MADER NEWS",
    "Employees": 9
  },
  {
    "Name": "MAINTECH FACILITY MAINTENANCE",
    "Employees": 16
  },
  {
    "Name": "MALCA AMIT ARMORED INC",
    "Employees": 12
  },
  {
    "Name": "MALCOLM DRILLING CO INC",
    "Employees": 20
  },
  {
    "Name": "MALONZO INC.",
    "Employees": 1
  },
  {
    "Name": "MARRS SERVICES INC",
    "Employees": 2
  },
  {
    "Name": "MARSHALL RETAIL GROUP",
    "Employees": 9
  },
  {
    "Name": "MARTIN BROS./ MARCOWALL INC",
    "Employees": 60
  },
  {
    "Name": "MARTIN HARRIS CONSTRUCTION",
    "Employees": 12
  },
  {
    "Name": "MARTIN INTEGRATED",
    "Employees": 11
  },
  {
    "Name": "MASONRY CONCEPTS",
    "Employees": 5
  },
  {
    "Name": "MASTER LIGHTNING SECURITY SOLUTIONS",
    "Employees": 59
  },
  {
    "Name": "MATRIX ENVIRONMENTAL",
    "Employees": 53
  },
  {
    "Name": "MAXIM SECURITY SYSTEMS",
    "Employees": 3
  },
  {
    "Name": "MBJ CONSULTANTS",
    "Employees": 4
  },
  {
    "Name": "MCCLONE CONSTRUCTION",
    "Employees": 6
  },
  {
    "Name": "MCDONOUGH ELEVATORS SALES AND RENTALS",
    "Employees": 2
  },
  {
    "Name": "MCKENDRY DOOR SALES",
    "Employees": 1
  },
  {
    "Name": "MCKEON DOOR WEST INC",
    "Employees": 9
  },
  {
    "Name": "MCKISSACK AND MCKISSACK",
    "Employees": 2
  },
  {
    "Name": "MEDINA PEST CONTROL",
    "Employees": 1
  },
  {
    "Name": "MERGEN CONSTRUCTION",
    "Employees": 3
  },
  {
    "Name": "METCO SPECIALTIES",
    "Employees": 5
  },
  {
    "Name": "METRO VIDEO",
    "Employees": 2
  },
  {
    "Name": "MFS FRAMING AND DRYWALL",
    "Employees": 7
  },
  {
    "Name": "MIANSAI INC",
    "Employees": 7
  },
  {
    "Name": "MID VALLEY ENGINEERING",
    "Employees": 4
  },
  {
    "Name": "MIKE ZARP INC",
    "Employees": 1
  },
  {
    "Name": "MISSION BEVERAGE",
    "Employees": 6
  },
  {
    "Name": "ML WINTERS CO",
    "Employees": 2
  },
  {
    "Name": "MOCA SYSTEMS",
    "Employees": 1
  },
  {
    "Name": "MOKULELE FLIGHT SERVICES",
    "Employees": 5
  },
  {
    "Name": "MONTGOMERY HARDWARE",
    "Employees": 1
  },
  {
    "Name": "MORGNER CONSTRUCTION MGMNT",
    "Employees": 2
  },
  {
    "Name": "MORPHO DETECTION INC",
    "Employees": 27
  },
  {
    "Name": "MORPHOTRUST USA, INC",
    "Employees": 2
  },
  {
    "Name": "MOTOROLA INC",
    "Employees": 2
  },
  {
    "Name": "MOYE CONSULTING",
    "Employees": 3
  },
  {
    "Name": "MR CRANE",
    "Employees": 1
  },
  {
    "Name": "MSA SECURITY",
    "Employees": 13
  },
  {
    "Name": "MSC INDUSTRIAL SUPPLY CO",
    "Employees": 7
  },
  {
    "Name": "MTGL INC",
    "Employees": 23
  },
  {
    "Name": "MUIR CHASE PLUMBING CO",
    "Employees": 15
  },
  {
    "Name": "MURRAY COMPANY",
    "Employees": 67
  },
  {
    "Name": "MUTUAL PROPANE",
    "Employees": 13
  },
  {
    "Name": "NATIONAL DCP LLC",
    "Employees": 3
  },
  {
    "Name": "NEVELL GROUP",
    "Employees": 25
  },
  {
    "Name": "NEW STARS MAINTENANCE SERVICES LLC",
    "Employees": 1
  },
  {
    "Name": "NINYO AND MOORE",
    "Employees": 8
  },
  {
    "Name": "NIPPON CARGO",
    "Employees": 15
  },
  {
    "Name": "NMI INDUSTRIAL HOLDINGS",
    "Employees": 6
  },
  {
    "Name": "NOR CAL PIPELINE SERVICES",
    "Employees": 1
  },
  {
    "Name": "NORTH AMERICAN CRANE CO",
    "Employees": 2
  },
  {
    "Name": "NORTH CAROLINA AVIATION SVCS",
    "Employees": 8
  },
  {
    "Name": "NORTHROP GRUMMAN",
    "Employees": 19
  },
  {
    "Name": "NOTHING FILMS INC",
    "Employees": 3
  },
  {
    "Name": "NS STRUCTURAL ENGINEERING INC",
    "Employees": 1
  },
  {
    "Name": "OCEAN BLUE ENVIRONMENTAL SERVICES",
    "Employees": 11
  },
  {
    "Name": "ODEMCO",
    "Employees": 1
  },
  {
    "Name": "ORKIN PEST CONTROL",
    "Employees": 32
  },
  {
    "Name": "OTIS ELEVATOR CO",
    "Employees": 68
  },
  {
    "Name": "P AND L SOLUTIONS",
    "Employees": 2
  },
  {
    "Name": "P2S ENGINEERING INC",
    "Employees": 10
  },
  {
    "Name": "PACIFIC ARCHITECTURAL WOODWORKING",
    "Employees": 5
  },
  {
    "Name": "PACIFIC TELEMANAGEMENT SERVICES",
    "Employees": 3
  },
  {
    "Name": "PACIFIC WALL SYSTEMS, INC.",
    "Employees": 11
  },
  {
    "Name": "PACIFICA SERVICES INC",
    "Employees": 3
  },
  {
    "Name": "PADCOM DCM",
    "Employees": 4
  },
  {
    "Name": "PAN PACIFIC MECHANICAL",
    "Employees": 45
  },
  {
    "Name": "PANASONIC AVIONICS CORP",
    "Employees": 44
  },
  {
    "Name": "PAPYRUS RECYCLED GREETINGS INC",
    "Employees": 2
  },
  {
    "Name": "PARADIES",
    "Employees": 76
  },
  {
    "Name": "PARAGON PROJECT RESOURCES INC",
    "Employees": 1
  },
  {
    "Name": "PARKHOUSE TIRE INC",
    "Employees": 4
  },
  {
    "Name": "PARSONS CONSTRUCTORS INC",
    "Employees": 3
  },
  {
    "Name": "PARSONS GOVERNMENT SERVICES",
    "Employees": 2
  },
  {
    "Name": "PARSONS TRANSPORTATION GROUP",
    "Employees": 47
  },
  {
    "Name": "PASLAY MANAGEMENT GROUP",
    "Employees": 4
  },
  {
    "Name": "PBS ENGINEERS INC",
    "Employees": 26
  },
  {
    "Name": "PCI",
    "Employees": 12
  },
  {
    "Name": "PCL CONSTRUCTION SERVICES",
    "Employees": 85
  },
  {
    "Name": "PENHALL",
    "Employees": 40
  },
  {
    "Name": "PENN AIR CONTROL INC",
    "Employees": 1
  },
  {
    "Name": "PEPSI",
    "Employees": 18
  },
  {
    "Name": "PEREZ CONSTRUCTION",
    "Employees": 2
  },
  {
    "Name": "PERFECT POLISH",
    "Employees": 13
  },
  {
    "Name": "PERFORMANCE ABATEMENT SERVICES",
    "Employees": 1
  },
  {
    "Name": "PFEILER AND ASSOCIATES ENGINEERS",
    "Employees": 6
  },
  {
    "Name": "PFT ALEXANDER INC",
    "Employees": 2
  },
  {
    "Name": "PHILIPPINE AIRLINES",
    "Employees": 5
  },
  {
    "Name": "PICK UP STIX",
    "Employees": 2
  },
  {
    "Name": "PIERCE GOODWIN ALEXANDER AND LINVILLE",
    "Employees": 8
  },
  {
    "Name": "PINKBERRY",
    "Employees": 15
  },
  {
    "Name": "PINNACLE DESIGNS",
    "Employees": 4
  },
  {
    "Name": "PLANET EXPRESS LAX LLC",
    "Employees": 54
  },
  {
    "Name": "PM TECHNOLOGY INC",
    "Employees": 9
  },
  {
    "Name": "PMA CONSULTANTS",
    "Employees": 3
  },
  {
    "Name": "PMCS GROUP",
    "Employees": 3
  },
  {
    "Name": "POLAR AIR",
    "Employees": 23
  },
  {
    "Name": "POLARIS ELECTRIC",
    "Employees": 2
  },
  {
    "Name": "POLYTECHNIQUE ENVIRONMENTAL INC",
    "Employees": 1
  },
  {
    "Name": "PRADEEP CONSULTING",
    "Employees": 1
  },
  {
    "Name": "PREFERRED CEILINGS",
    "Employees": 23
  },
  {
    "Name": "PREMIER INTERIOR DEVELOPMENT INC",
    "Employees": 28
  },
  {
    "Name": "PREMIER TILE AND MARBLE",
    "Employees": 9
  },
  {
    "Name": "PREMIERE ENGINEERING AND GRADING INC",
    "Employees": 9
  },
  {
    "Name": "PREMISE HEALTH",
    "Employees": 7
  },
  {
    "Name": "PRISTINE FLEET INC",
    "Employees": 8
  },
  {
    "Name": "PRO STEEL ERECTORS",
    "Employees": 27
  },
  {
    "Name": "PROFESSIONAL AVIATION MARKETING, INC",
    "Employees": 49
  },
  {
    "Name": "PROJECT SERVICES AND MESSAGING MANAGEMENT",
    "Employees": 9
  },
  {
    "Name": "PROLOGIX",
    "Employees": 5
  },
  {
    "Name": "PROSPECTRA CONTRACT FLOORING",
    "Employees": 6
  },
  {
    "Name": "PSOMAS",
    "Employees": 7
  },
  {
    "Name": "QANTAS",
    "Employees": 96
  },
  {
    "Name": "QATAR AIRWAYS",
    "Employees": 16
  },
  {
    "Name": "QUALITY COAST INC",
    "Employees": 13
  },
  {
    "Name": "QUALITY PRODUCTION SERVICES INC",
    "Employees": 28
  },
  {
    "Name": "RANDALL MCANANY",
    "Employees": 8
  },
  {
    "Name": "RAPISCAN SECURITY PRODUCTS",
    "Employees": 10
  },
  {
    "Name": "READYJET INC",
    "Employees": 27
  },
  {
    "Name": "REAL FOOD DAILY",
    "Employees": 2
  },
  {
    "Name": "REBAR ENGINEERING",
    "Employees": 6
  },
  {
    "Name": "RELIANT IMMEDIATE CARE",
    "Employees": 7
  },
  {
    "Name": "RG GROUP GLOBAL INC",
    "Employees": 1
  },
  {
    "Name": "RICHARD C HONORE CONSTRUCTION",
    "Employees": 11
  },
  {
    "Name": "RICONDO AND ASSOCIATES",
    "Employees": 4
  },
  {
    "Name": "RIVERS AND CHRISTIAN",
    "Employees": 18
  },
  {
    "Name": "RJ AND J CONSTRUCTION INC",
    "Employees": 5
  },
  {
    "Name": "RJ POTOSKI CONSULTING INC",
    "Employees": 1
  },
  {
    "Name": "RMA GROUP",
    "Employees": 1
  },
  {
    "Name": "RMP SAFETY SERVICES",
    "Employees": 1
  },
  {
    "Name": "ROCK AND BREWS",
    "Employees": 4
  },
  {
    "Name": "ROCK-IT CARGO USA",
    "Employees": 26
  },
  {
    "Name": "ROLLS ROYCE INC",
    "Employees": 1
  },
  {
    "Name": "RON STOLIAR CONSULTING LLC",
    "Employees": 1
  },
  {
    "Name": "ROSENDIN ELECTRIC  INC",
    "Employees": 72
  },
  {
    "Name": "ROSS AND BARUZZINI",
    "Employees": 5
  },
  {
    "Name": "ROYAL AIRLINE LINEN",
    "Employees": 13
  },
  {
    "Name": "ROYAL ELECTRIC",
    "Employees": 37
  },
  {
    "Name": "RPM AUTO AND AIRCRAFT",
    "Employees": 5
  },
  {
    "Name": "RR WEST COAST LLC",
    "Employees": 2
  },
  {
    "Name": "RS AND H CALIFORNIA INC",
    "Employees": 13
  },
  {
    "Name": "RUNO INC",
    "Employees": 1
  },
  {
    "Name": "RURAL ELECTRIC",
    "Employees": 1
  },
  {
    "Name": "RUTHERFORD",
    "Employees": 23
  },
  {
    "Name": "S A S GROUP",
    "Employees": 3
  },
  {
    "Name": "S AND K ENGINEERS",
    "Employees": 5
  },
  {
    "Name": "S I T A",
    "Employees": 38
  },
  {
    "Name": "S1 SAFETY FIRST",
    "Employees": 1
  },
  {
    "Name": "SADDLEBACK WATERPROOFING",
    "Employees": 11
  },
  {
    "Name": "SAFEWORK INC",
    "Employees": 4
  },
  {
    "Name": "SAGE PARTS PLUS",
    "Employees": 18
  },
  {
    "Name": "SAIFUL BOUQUET",
    "Employees": 1
  },
  {
    "Name": "SAN MAR CONSTRUCTION COMPANY",
    "Employees": 2
  },
  {
    "Name": "SANA",
    "Employees": 5
  },
  {
    "Name": "SANTA MONICA SEAFOOD",
    "Employees": 4
  },
  {
    "Name": "SATTERFIELD AND PONTIKES CONSTRUCTION",
    "Employees": 20
  },
  {
    "Name": "SATWIC INC",
    "Employees": 1
  },
  {
    "Name": "SAUDI ARABIAN AIRLINES",
    "Employees": 12
  },
  {
    "Name": "SAVALA EQUIPMENT COMPANY",
    "Employees": 18
  },
  {
    "Name": "SB SHINE FLEET WASH",
    "Employees": 2
  },
  {
    "Name": "SBT PROMOTION",
    "Employees": 41
  },
  {
    "Name": "SCAQMD",
    "Employees": 5
  },
  {
    "Name": "SCHINDLER ELEVATOR CORPORATION",
    "Employees": 9
  },
  {
    "Name": "SCIS AIR SECURITY CORPORATION",
    "Employees": 57
  },
  {
    "Name": "SCV FACILITIES SERVICES",
    "Employees": 9
  },
  {
    "Name": "SE PIPELINE CONSTRUCTION",
    "Employees": 7
  },
  {
    "Name": "SECURITY VAULT WORKS, INC",
    "Employees": 2
  },
  {
    "Name": "SEELEY BROTHERS",
    "Employees": 1
  },
  {
    "Name": "SELBERT PERKINS DESIGN",
    "Employees": 1
  },
  {
    "Name": "SELECT MEDIA SERVICES LLC",
    "Employees": 7
  },
  {
    "Name": "SELECT PHYSICAL THERAPY",
    "Employees": 4
  },
  {
    "Name": "SEQUOIA CONSULTANTS",
    "Employees": 15
  },
  {
    "Name": "SERVICETEC INTERNATIONAL",
    "Employees": 7
  },
  {
    "Name": "SERVICON SYSTEMS INC",
    "Employees": 5
  },
  {
    "Name": "SG ENGINEERING SOLUTIONS",
    "Employees": 1
  },
  {
    "Name": "SHAMROCK FOODS COMPANY",
    "Employees": 6
  },
  {
    "Name": "SHARED SOLUTIONS AND SERVICES INC",
    "Employees": 2
  },
  {
    "Name": "SHELAGHS PLANTSCAPES",
    "Employees": 2
  },
  {
    "Name": "SHEWARD AND SONS AND SONS INC",
    "Employees": 4
  },
  {
    "Name": "SHORING ENGINEERS",
    "Employees": 34
  },
  {
    "Name": "SHOWCASE FACILITY SOLUTIONS",
    "Employees": 3
  },
  {
    "Name": "SIA ENGINEERING USA INC",
    "Employees": 83
  },
  {
    "Name": "SICK INC",
    "Employees": 1
  },
  {
    "Name": "SIDS AIR CONDITIONING",
    "Employees": 1
  },
  {
    "Name": "SIEMENS INDUSTRY INC",
    "Employees": 28
  },
  {
    "Name": "SIEMENS POSTAL PARCEL AND AIRPORT LOGISTICS LLC",
    "Employees": 11
  },
  {
    "Name": "SIGN INDUSTRIES INC",
    "Employees": 3
  },
  {
    "Name": "SIGNATURE FLOORING",
    "Employees": 6
  },
  {
    "Name": "SILVERADO TILE AND STONE",
    "Employees": 2
  },
  {
    "Name": "SIMPSON AND SIMPSON MANAGEMENT CONSULTING",
    "Employees": 3
  },
  {
    "Name": "SINGAPORE AIRLINES",
    "Employees": 12
  },
  {
    "Name": "SINGAPORE CARGO",
    "Employees": 11
  },
  {
    "Name": "SITE SAFETY LLC",
    "Employees": 1
  },
  {
    "Name": "SKIDMORE OWINGS AND MERRILL LLP",
    "Employees": 2
  },
  {
    "Name": "SKYCON, INC",
    "Employees": 6
  },
  {
    "Name": "SKYWEST AIR",
    "Employees": 48
  },
  {
    "Name": "SMARTE CARTE",
    "Employees": 58
  },
  {
    "Name": "SMITH EMERY",
    "Employees": 10
  },
  {
    "Name": "SMITH NOVELTY COMPANY",
    "Employees": 4
  },
  {
    "Name": "SMITHGROUPJJR",
    "Employees": 2
  },
  {
    "Name": "SMOKE GUARD CALIFORNIA",
    "Employees": 1
  },
  {
    "Name": "SNAP-ON TOOLS",
    "Employees": 1
  },
  {
    "Name": "SNI RETAIL SOLUTIONS",
    "Employees": 3
  },
  {
    "Name": "SO CAL INSULATION INC",
    "Employees": 3
  },
  {
    "Name": "SO CAL SANITATION",
    "Employees": 20
  },
  {
    "Name": "SOCAL JET SERVICES",
    "Employees": 21
  },
  {
    "Name": "SONOMA TECHNOLOGY INC",
    "Employees": 1
  },
  {
    "Name": "SONY AVIATION",
    "Employees": 6
  },
  {
    "Name": "SOS SECURITY INC",
    "Employees": 79
  },
  {
    "Name": "SOUTH BAY CLEANING COMPANY",
    "Employees": 3
  },
  {
    "Name": "SOUTHERN AIR INC",
    "Employees": 4
  },
  {
    "Name": "SOUTHERN CALIFORNIA GRADING INC",
    "Employees": 4
  },
  {
    "Name": "SOUTHERN WINE AND SPIRITS OF CALIFORNIA",
    "Employees": 14
  },
  {
    "Name": "SOUTHWEST GEOPHYSICS INC",
    "Employees": 2
  },
  {
    "Name": "SOUTHWEST STEEL",
    "Employees": 10
  },
  {
    "Name": "SPECIALTY INSTALLATION INC",
    "Employees": 8
  },
  {
    "Name": "SPIRIT AIRLINES",
    "Employees": 9
  },
  {
    "Name": "SRA INTERNATIONAL INC",
    "Employees": 2
  },
  {
    "Name": "SSP AMERICA",
    "Employees": 51
  },
  {
    "Name": "STANDARDAERO",
    "Employees": 80
  },
  {
    "Name": "STANHOPE",
    "Employees": 11
  },
  {
    "Name": "STANTRU RESOURCES INC",
    "Employees": 3
  },
  {
    "Name": "STARBUCKS COFFEE COMPANY",
    "Employees": 1
  },
  {
    "Name": "STERLING BANK SERVICES",
    "Employees": 1
  },
  {
    "Name": "STERNDAHL ENTERPRISES INC",
    "Employees": 33
  },
  {
    "Name": "STEVE BUBALO CONSTRUCTION CO INC",
    "Employees": 21
  },
  {
    "Name": "STEVES CLEANING AND DISINFECTING",
    "Employees": 3
  },
  {
    "Name": "STS AEROSTAFF SERVICES",
    "Employees": 20
  },
  {
    "Name": "STUMBAUGH",
    "Employees": 9
  },
  {
    "Name": "STV INC",
    "Employees": 21
  },
  {
    "Name": "SUBURBAN PROPANE",
    "Employees": 10
  },
  {
    "Name": "SUN COUNTRY AIRLINES",
    "Employees": 3
  },
  {
    "Name": "SUNBELT RENTALS INC",
    "Employees": 4
  },
  {
    "Name": "SUNRISE PRODUCE COMPANY",
    "Employees": 4
  },
  {
    "Name": "SUNSTATE EQUIPMENT",
    "Employees": 11
  },
  {
    "Name": "SUPPLYWORKS",
    "Employees": 3
  },
  {
    "Name": "SWANSON RINK",
    "Employees": 1
  },
  {
    "Name": "SWINERTON BUILDERS",
    "Employees": 31
  },
  {
    "Name": "SWISS",
    "Employees": 13
  },
  {
    "Name": "SWISSPORT CORPORATION",
    "Employees": 28
  },
  {
    "Name": "SYGMA NETWORK INC",
    "Employees": 1
  },
  {
    "Name": "SYNOVOS INC",
    "Employees": 1
  },
  {
    "Name": "SYSCO LOS ANGELES INC",
    "Employees": 18
  },
  {
    "Name": "SYSKA HENNESSY GROUP",
    "Employees": 3
  },
  {
    "Name": "T B PENICK AND SONS INC",
    "Employees": 4
  },
  {
    "Name": "T G P ENTERPRISES INC",
    "Employees": 13
  },
  {
    "Name": "T. BRENNAN, INC.",
    "Employees": 12
  },
  {
    "Name": "TACA",
    "Employees": 4
  },
  {
    "Name": "TAFT ELECTRIC COMPANY",
    "Employees": 27
  },
  {
    "Name": "TAIT ENVIRONMENTAL SERVICES INC",
    "Employees": 1
  },
  {
    "Name": "TANDEM GSE",
    "Employees": 9
  },
  {
    "Name": "TEC MANAGEMENT CONSULTANTS INC",
    "Employees": 34
  },
  {
    "Name": "TERABAND TECHNOLOGIES INC",
    "Employees": 12
  },
  {
    "Name": "TG CONSTRUCTION",
    "Employees": 9
  },
  {
    "Name": "THALES AVIONICS",
    "Employees": 24
  },
  {
    "Name": "THE BEAD FACTORY",
    "Employees": 7
  },
  {
    "Name": "THE BOEING COMPANY",
    "Employees": 16
  },
  {
    "Name": "THE CARGO SECURITY COMPANY",
    "Employees": 34
  },
  {
    "Name": "THE COUNTER",
    "Employees": 1
  },
  {
    "Name": "THE HABIT BURGER GRILL",
    "Employees": 2
  },
  {
    "Name": "THE INTERNATIONAL GROUP TECHNOLOGIES",
    "Employees": 1
  },
  {
    "Name": "THE NORTH HIGHLAND COMPANY",
    "Employees": 1
  },
  {
    "Name": "THE WORLD PROTECTION GROUP",
    "Employees": 4
  },
  {
    "Name": "THERMALAIR",
    "Employees": 1
  },
  {
    "Name": "THYSSENKRUPP AIRPORT SYSTEMS INC",
    "Employees": 2
  },
  {
    "Name": "THYSSENKRUPP INDUSTRIAL SERVICES NA, INC",
    "Employees": 6
  },
  {
    "Name": "TIME WARNER CABLE",
    "Employees": 30
  },
  {
    "Name": "TITAN POWER",
    "Employees": 2
  },
  {
    "Name": "TNT EXPRESS WORLDWIDE",
    "Employees": 5
  },
  {
    "Name": "TOFFLEMIRE FREIGHT SVC",
    "Employees": 9
  },
  {
    "Name": "TORRANCE LOGISTICS COMPANY LLC",
    "Employees": 2
  },
  {
    "Name": "TOSHIBA BUSINESS SOLUTIONS",
    "Employees": 1
  },
  {
    "Name": "TRACESTAR",
    "Employees": 1
  },
  {
    "Name": "TRANSPORTATION CHARTER SERVICES INC",
    "Employees": 14
  },
  {
    "Name": "TRAUNER CONSULTING SERVICES",
    "Employees": 1
  },
  {
    "Name": "TRENCH PLATE RENTAL COMPANY",
    "Employees": 8
  },
  {
    "Name": "TRENCH SHORING COMPANY",
    "Employees": 2
  },
  {
    "Name": "TRI COUNTY DRILLING INC",
    "Employees": 1
  },
  {
    "Name": "TRIMARK RAYGAL INC",
    "Employees": 7
  },
  {
    "Name": "TRMI SYSTEMS INTEGRATION",
    "Employees": 2
  },
  {
    "Name": "TTG ENGINEERS",
    "Employees": 4
  },
  {
    "Name": "TUG SERVICE CENTER NETWORK LLC",
    "Employees": 4
  },
  {
    "Name": "TUG TECHNOLOGIES CORPORATION",
    "Employees": 1
  },
  {
    "Name": "TUMI INC",
    "Employees": 8
  },
  {
    "Name": "TURKISH AIRLINES",
    "Employees": 24
  },
  {
    "Name": "TURNER CONSTRUCTION COMPANY",
    "Employees": 87
  },
  {
    "Name": "TWINING LABORATORIES",
    "Employees": 25
  },
  {
    "Name": "TY INC",
    "Employees": 1
  },
  {
    "Name": "TY LIN INTERNATIONAL",
    "Employees": 8
  },
  {
    "Name": "U. S.  AIR FORCE",
    "Employees": 63
  },
  {
    "Name": "U. S.  COAST GUARD",
    "Employees": 6
  },
  {
    "Name": "U. S.  COMMERCE DEPT",
    "Employees": 10
  },
  {
    "Name": "U. S.  DEA TASK FORCE",
    "Employees": 28
  },
  {
    "Name": "U. S.  DEPARTMENT OF AGRICULTURE",
    "Employees": 30
  },
  {
    "Name": "U. S.  F.B.I.",
    "Employees": 24
  },
  {
    "Name": "U. S.  F.D.A.",
    "Employees": 40
  },
  {
    "Name": "U. S.  FISH AND WILDLIFE",
    "Employees": 18
  },
  {
    "Name": "U. S.  JUSTICE DEPT.",
    "Employees": 9
  },
  {
    "Name": "U. S.  MARSHAL",
    "Employees": 28
  },
  {
    "Name": "U. S.  STATE DEPARTMENT",
    "Employees": 37
  },
  {
    "Name": "U. S.  WEATHER SVC",
    "Employees": 3
  },
  {
    "Name": "U.S. FOODSERVICE, INC.",
    "Employees": 11
  },
  {
    "Name": "ULTIMATE SECURITY SERVICES",
    "Employees": 33
  },
  {
    "Name": "UNDERGROUND CONSTRUCTION CO., INC.",
    "Employees": 6
  },
  {
    "Name": "UNIQUE PAINTING AND ARTISTRY INC",
    "Employees": 5
  },
  {
    "Name": "UNISAN PRODUCTS LLC",
    "Employees": 3
  },
  {
    "Name": "UNISERVE FACILITIES SERVICES CORP",
    "Employees": 33
  },
  {
    "Name": "UNISON CONSULTING INC",
    "Employees": 1
  },
  {
    "Name": "UNISOURCE SOLUTIONS",
    "Employees": 5
  },
  {
    "Name": "UNITED RENTALS INC",
    "Employees": 20
  },
  {
    "Name": "UNITED RIGGERS AND ERECTORS",
    "Employees": 2
  },
  {
    "Name": "UNITED SITE SERVICES",
    "Employees": 2
  },
  {
    "Name": "UNITED STATES PUBLIC HEALTH",
    "Employees": 4
  },
  {
    "Name": "UNITED STATES SECRET SERVICE",
    "Employees": 6
  },
  {
    "Name": "UNIVERSAL SECURITY ENTERPRISE",
    "Employees": 1
  },
  {
    "Name": "UNIVERSITY FOODS",
    "Employees": 5
  },
  {
    "Name": "UPS",
    "Employees": 86
  },
  {
    "Name": "UPS CARTAGE SERVICES INC",
    "Employees": 38
  },
  {
    "Name": "USA TODAY",
    "Employees": 3
  },
  {
    "Name": "VANDERLANDE INDUSTRIES",
    "Employees": 72
  },
  {
    "Name": "VANILLA BAKE SHOP",
    "Employees": 2
  },
  {
    "Name": "VANIR ASL",
    "Employees": 9
  },
  {
    "Name": "VCA ENGINEERS INC",
    "Employees": 6
  },
  {
    "Name": "VENDING ONE INC",
    "Employees": 3
  },
  {
    "Name": "VENEKLASEN  ASSOCIATES, INC",
    "Employees": 2
  },
  {
    "Name": "VIBRANT CARE REHABILITATION",
    "Employees": 7
  },
  {
    "Name": "VIC THOMPSON COMPANY",
    "Employees": 5
  },
  {
    "Name": "VINO VOLO",
    "Employees": 10
  },
  {
    "Name": "VIRGIN ATLANTIC",
    "Employees": 13
  },
  {
    "Name": "VIRGIN AUSTRALIA INTERNATIONAL AIRLINES",
    "Employees": 9
  },
  {
    "Name": "VISTA ENVIRONMENTAL CONSULTING",
    "Employees": 6
  },
  {
    "Name": "VNY- VAN NUYS AIRPORT",
    "Employees": 36
  },
  {
    "Name": "VOLARIS",
    "Employees": 3
  },
  {
    "Name": "VR CAMELOT INC",
    "Employees": 9
  },
  {
    "Name": "VS AIRCRAFT MAINTENANCE SPECIALIST",
    "Employees": 13
  },
  {
    "Name": "VSI",
    "Employees": 2
  },
  {
    "Name": "W. W. GRAINGER INC",
    "Employees": 8
  },
  {
    "Name": "WAAG",
    "Employees": 1
  },
  {
    "Name": "WAGNER ENGINEERING AND SURVEY INC",
    "Employees": 6
  },
  {
    "Name": "WASHINGTON IRON WORKS",
    "Employees": 28
  },
  {
    "Name": "WASTE MANAGEMENT",
    "Employees": 4
  },
  {
    "Name": "WAXIE SANITARY SUPPLY",
    "Employees": 5
  },
  {
    "Name": "WDFG",
    "Employees": 21
  },
  {
    "Name": "WE ONEIL CONSTRUCTION COMPANY OF CALIFORNIA",
    "Employees": 11
  },
  {
    "Name": "WE SERVICE AMERICA",
    "Employees": 7
  },
  {
    "Name": "WEINBAUM MANAGEMENT GROUP",
    "Employees": 3
  },
  {
    "Name": "WEST COAST CABLE, INC",
    "Employees": 25
  },
  {
    "Name": "WEST COAST FIRESTOPPING INC",
    "Employees": 3
  },
  {
    "Name": "WESTCORP",
    "Employees": 5
  },
  {
    "Name": "WESTERN AIR LIMBACH",
    "Employees": 89
  },
  {
    "Name": "WESTERN ALLIED CORPORATION",
    "Employees": 18
  },
  {
    "Name": "WESTERN EXTERMINATOR CO.",
    "Employees": 3
  },
  {
    "Name": "WESTERN INDUSTRIAL CONTRACTORS",
    "Employees": 33
  },
  {
    "Name": "WESTFIELD AIRPORTS LLC",
    "Employees": 33
  },
  {
    "Name": "WESTSIDE BUILDING MATERIALS",
    "Employees": 14
  },
  {
    "Name": "WFS EXPRESS INC",
    "Employees": 78
  },
  {
    "Name": "WILDLANDS CONSERVATION SCIENCE LLC",
    "Employees": 1
  },
  {
    "Name": "WILSON AND HAMPTON PAINTING",
    "Employees": 20
  },
  {
    "Name": "WINE WAREHOUSE",
    "Employees": 6
  },
  {
    "Name": "WMB ASSOCIATES",
    "Employees": 2
  },
  {
    "Name": "WOLFGANG PUCK",
    "Employees": 6
  },
  {
    "Name": "WOLVERINE FIRE PROTECTION CO.",
    "Employees": 4
  },
  {
    "Name": "WOODBRIDGE GLASS",
    "Employees": 14
  },
  {
    "Name": "WORLD BNOTES EXCHANGE INC",
    "Employees": 4
  },
  {
    "Name": "WORLDWIDE PRODUCE",
    "Employees": 4
  },
  {
    "Name": "WSP USA INC",
    "Employees": 1
  },
  {
    "Name": "X SPATIAL",
    "Employees": 1
  },
  {
    "Name": "XCEL MECHANICAL SYSTEMS, INC.",
    "Employees": 24
  },
  {
    "Name": "XIAMEN AIRLINES",
    "Employees": 1
  },
  {
    "Name": "XL FIRE PROTECTION",
    "Employees": 24
  },
  {
    "Name": "XPRES SPA",
    "Employees": 31
  },
  {
    "Name": "YOUNGS MARKET COMPANY LLC",
    "Employees": 14
  },
  {
    "Name": "Z ACAMS TEST CO 2",
    "Employees": 1
  },
  {
    "Name": "ZOLNAY INSULATION",
    "Employees": 9
  },
  {
    "Name": "ZOOM SYSTEMS",
    "Employees": 1
  }
]
}


// WEBPACK FOOTER //
// ./src/corps.js